import type { Props } from './types';
import type { ReCAPTCHAHandle } from '@steamer-academy/react-google-recaptcha';

import { useCallback } from 'react';

import ReCAPTCHA from '@steamer-academy/react-google-recaptcha';

import { checkIfRecaptchaRequired } from './utils';
import { env } from '@/app/env';

export const CustomReCAPTCHA = ({
  onChange,
  ref,
  ...props
}: Props & { ref: React.RefObject<ReCAPTCHAHandle | null> }) => {
  const handleChange = useCallback(
    (token: string | null) => {
      if (checkIfRecaptchaRequired()) {
        onChange?.(token);
      }
    },
    [onChange],
  );

  if (!checkIfRecaptchaRequired()) {
    return null;
  }

  return (
    <ReCAPTCHA
      onChange={handleChange}
      ref={ref}
      sitekey={env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}
      size="invisible"
      {...props}
    />
  );
};
